import { Card, CardContent, Typography } from "@mui/material";
import MarketMonkeyFlowContainer from "./market-money-flow/MarketMonkeyFlowContainer";
import PercentRanges from "./percent-ranges/PercentRanges";
import Grid2 from "@mui/material/Unstable_Grid2";

const DashboardStatusMarket = () => {
    return (
        <Card sx={{ minHeight: 300, boxShadow: "none" }}>
            <CardContent
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "20px",
                }}
            >
                <Typography
                    sx={{
                        textAlign: "center",
                        fontSize: { xs: "16px", lg: "18px" },
                        fontWeight: 700,
                    }}
                >
                    وضعیت بازار
                </Typography>
                <Grid2 container spacing={2}>
                    <Grid2 xs={12} lg={6}>
                        <PercentRanges />
                    </Grid2>
                    <Grid2 xs={12} lg={6}>
                        <MarketMonkeyFlowContainer />
                    </Grid2>
                </Grid2>
            </CardContent>
        </Card>
    );
};

export default DashboardStatusMarket;